import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.scss'],
})
export class PersonalComponent  implements OnInit {
  contactId!: number
  contact!: CustomerContact

  form = new FormGroup({
    email: new FormControl('', [Validators.email, Validators.required]),
    first_name: new FormControl('', [Validators.required]),
    last_name: new FormControl('', [Validators.required]),
    mobile_phone: new FormControl(''),
  }) 

  constructor(private settingsService: SettingsService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.settingsService.get().subscribe(settings => {
      this.contact = settings

      this.form.patchValue(settings)
    })
  }

  save() {
    this.settingsService.save(this.form.value).subscribe(_data => {
      this.activeModal.close()
    })
  }
}
